import { NgTemplateOutlet } from '@angular/common';
import { Component, TemplateRef, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { TaskDetailsHeaderComponent } from '@app/components/task/task-splitview-list/task-details-content/task-details-header/task-details-header.component';
import { TaskDetailsMetadataPanelComponent } from '@app/components/task/task-splitview-list/task-details-content/task-details-metadata-panel/task-details-metadata-panel.component';
import {
  TASK_DETAILS_TABS,
  TaskDetailsTab
} from '@app/components/task/task-splitview-list/task-details-content/task-details-tab.enum';
import { TaskType } from '@app/shared/types/models/task/task-type.model';
import { Task } from '@app/shared/types/models/task/task.model';
import { UiCardComponent } from '@app/shared/ui/card/ui-card.component';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * PROPOZYCJA — DO WERYFIKACJI
 *
 * @summary Mobile physical screen for the task details panel. Stateless presentational
 * component: it renders the mobile layout (card header, metadata, tabs) and projects the
 * tab/subtasks content supplied by {@link TaskDetailsContentComponent} via `TemplateRef`.
 * All interactions are forwarded as outputs to the parent controller, which owns business
 * logic, state, and effects.
 * @selector proffeo-task-details-mobile-screen
 */
@Component({
  selector: 'proffeo-task-details-mobile-screen',
  templateUrl: './task-details-mobile-screen.component.html',
  styleUrl: './task-details-mobile-screen.component.scss',
  host: {
    class: 'flex w-full min-w-0 flex-col gap-2.5 overflow-x-hidden'
  },
  imports: [
    NgTemplateOutlet,
    MatIconModule,
    MatTabsModule,
    TranslatePipe,
    UiCardComponent,
    TaskDetailsHeaderComponent,
    TaskDetailsMetadataPanelComponent
  ]
})
export class TaskDetailsMobileScreenComponent {
  protected readonly taskTabs = TASK_DETAILS_TABS;

  public readonly task = input.required<Task>();
  public readonly taskTypes = input.required<TaskType[]>();
  public readonly taskActionsMenu = input.required<MatMenu>();
  public readonly isNameEditing = input.required<boolean>();
  public readonly maxTaskNameLength = input.required<number>();
  public readonly currentTabIndex = input.required<TaskDetailsTab>();
  public readonly tabContent = input.required<TemplateRef<unknown>>();
  public readonly subtasksContent = input.required<TemplateRef<unknown>>();

  public readonly closeRequested = output<void>();
  public readonly nameEditRequested = output<void>();
  public readonly nameEditCancelled = output<void>();
  public readonly taskNameChanged = output<string>();
  public readonly taskTypeSelected = output<TaskType>();
  public readonly timeReportRequested = output<Task>();
  public readonly timeReportsTabRequested = output<void>();
  public readonly tabSelected = output<{ index: TaskDetailsTab; event: MouseEvent }>();

  protected onTabClick(index: TaskDetailsTab, event: MouseEvent): void {
    this.tabSelected.emit({ index, event });
  }
}
